import { isObject } from 'lodash';

import { defaultErrors } from './constants';
import { setAuthError } from './okapiActions';

const getLoginErrors = (payload) => {
  try {
    if (isObject(payload)) {
      const { errors } = payload;

      return errors;
    } else {
      const { errors } = JSON.parse(payload);

      return errors || [defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR];
    }
  } catch (e) {
    return [defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR];
  }
};

const getLoginErrorsFromType = (payload) => {
  try {
    const [{ type }] = payload.errors;

    switch (type) {
      case '-5':
        return [{
          code: 'username.incorrect',
          type: 'error',
        }];
      case '-6':
        return [{
          code: 'password.incorrect',
          type: 'error',
        }];
      case '-7':
        return [{
          code: 'user.inactive',
          type: 'error',
        }];
      default:
        return [defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR];
    }
  } catch {
    return [defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR];
  }
};

/** Error code a ReČeK backend puts on a request rejected for a missing/invalid captcha (DB-876). */
const CAPTCHA_INVALID_CODE = 'CAPTCHA_INVALID';

/** Reads the error code of both the {errors:[{code}]} and the {error:{code}} response shapes. */
const getErrorCode = (payload) => {
  if (!isObject(payload)) {
    return undefined;
  }
  return payload.errors?.[0]?.code ?? payload.error?.code;
};

function getProcessedErrors(response, status, defaultClientError) {
  const clientError = defaultClientError || defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR;

  switch (status) {
    case 400:
      return getErrorCode(response) === CAPTCHA_INVALID_CODE
        ? [defaultErrors.CAPTCHA_INVALID_ERROR]
        : [clientError];
    case 401:
      return getLoginErrorsFromType(response);
    case 422:
      return getLoginErrors(response);
    case 404:
      return defaultClientError
        ? [defaultClientError]
        : [defaultErrors.DEFAULT_LOGIN_SERVER_ERROR];
    case 429:
      return [defaultErrors.TOO_MANY_REQUESTS_ERROR];
    case 500:
      return [defaultErrors.DEFAULT_LOGIN_SERVER_ERROR];
    default:
      return [clientError];
  }
}

export default async function processBadResponse(dispatch, response, defaultClientError) {
  let actionPayload;

  try {
    const responseBody = await response.json();
    const responsePayload = responseBody.errorMessage || responseBody;
    actionPayload = getProcessedErrors(responsePayload, response.status, defaultClientError);
  } catch (e) {
    // A rate limiter (gateway or module) may answer 429 without a JSON body.
    actionPayload = response?.status === 429
      ? [defaultErrors.TOO_MANY_REQUESTS_ERROR]
      : [defaultErrors.DEFAULT_LOGIN_CLIENT_ERROR];
  }
  dispatch(setAuthError(actionPayload));
}
